import { createFileRoute, redirect } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"
import { z } from "zod"

import { useAuthStore } from "@/features/auth/store"
import { canAccessFleetRemediation } from "@/features/fleet-remediation/access"
import { RemediationTable } from "@/features/fleet-remediation/components/RemediationTable"
import { SweepControlBar } from "@/features/fleet-remediation/components/SweepControlBar"

const searchSchema = z.object({
  device: z.number().int().optional(),
})

export const Route = createFileRoute("/_authed/remediation")({
  // Roller gelene kadar geçici: sadece süper admin (e-posta allowlist).
  beforeLoad: () => {
    if (!canAccessFleetRemediation(useAuthStore.getState().user?.email)) {
      throw redirect({ to: "/dashboard" })
    }
  },
  component: RemediationPage,
  validateSearch: (raw) => searchSchema.parse(raw),
})

function RemediationPage() {
  const { t } = useTranslation("fleet-remediation")
  const { device } = Route.useSearch()
  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="border-b border-ok-border px-6 py-4">
        <h1 className="text-lg font-semibold tracking-tight">{t("title")}</h1>
        <p className="text-xs text-ok-foreground-muted">{t("subtitle")}</p>
      </div>
      <div className="px-6 pt-4">
        <SweepControlBar />
      </div>
      <RemediationTable initialSelectedId={device ?? null} />
    </div>
  )
}
